import partial from "./partial.js";
export default function wrap(func, wrapper) {
  return partial(wrapper, func);
}
